import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalEntityAttendanceReadAction from './legalEntityAttendanceRead.action.json' with { type: 'json' }

const attendanceReadDefinition = defineReadAutoAction(
  legalEntityAttendanceReadAction,
  'legalEntityAttendance',
)

export default attendanceReadDefinition
